// Helper murni untuk Kanban Ticket. Dipisahkan dari komponen agar mudah diuji
// tanpa DOM dan dipakai bersama oleh board/column.
export const TICKET_KANBAN_LIMIT = 20

export const TICKET_KANBAN_STATUSES = ['open', 'in_progress', 'resolved']

export function buildTicketKanbanParams(filters, status, cursor, limit) {
  const source = filters || {}
  return {
    status: status,
    limit: Number(limit) > 0 ? Number(limit) : TICKET_KANBAN_LIMIT,
    cursor: cursor || '',
    keyword: String(source.keyword || '').trim(),
    category: source.category || '',
    priority: source.priority || '',
    assigned_agent_id: source.assigned_agent_id || ''
  }
}

// appendTicketKanbanItems menambahkan halaman berikutnya tanpa duplikasi id.
export function appendTicketKanbanItems(existing, incoming) {
  const base = Array.isArray(existing) ? existing.slice() : []
  const seen = {}
  base.forEach(ticket => {
    if (ticket && ticket.id !== undefined) seen[String(ticket.id)] = true
  })
  const additions = (Array.isArray(incoming) ? incoming : []).filter(ticket => {
    if (!ticket || ticket.id === undefined) return false
    const key = String(ticket.id)
    if (seen[key]) return false
    seen[key] = true
    return true
  })
  return base.concat(additions)
}

// Cursor backend berformat "<kanban_position>:<id>".
export function ticketKanbanCursorFromItems(items) {
  const list = Array.isArray(items) ? items : []
  const last = list[list.length - 1]
  if (!last) return null
  const position = Number(last.kanban_position)
  if (!position || !last.id) return null
  return position + ':' + last.id
}

export function ticketKanbanMatchesFilters(ticket, filters) {
  if (!ticket) return false
  const source = filters || {}
  const keyword = String(source.keyword || '').trim().toLowerCase()
  if (keyword) {
    const haystack = [
      ticket.ticket_number,
      ticket.contact_name,
      ticket.contact_number,
      ticket.title
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase()
    if (haystack.indexOf(keyword) === -1) return false
  }
  if (source.category && ticket.category !== source.category) return false
  if (source.priority && ticket.priority !== source.priority) return false
  if (
    source.assigned_agent_id &&
    String(ticket.assigned_agent_id || '') !== String(source.assigned_agent_id)
  ) {
    return false
  }
  return true
}

export function ticketKanbanHasActiveFilter(filters) {
  const source = filters || {}
  return !!(
    String(source.keyword || '').trim() ||
    source.category ||
    source.priority ||
    source.assigned_agent_id
  )
}

export function ticketKanbanSameOrder(left, right) {
  if (!Array.isArray(left) || !Array.isArray(right) || left.length !== right.length) {
    return false
  }
  for (let index = 0; index < left.length; index += 1) {
    const leftTicket = left[index] || {}
    const rightTicket = right[index] || {}
    if (String(leftTicket.id) !== String(rightTicket.id)) return false
  }
  return true
}



// WEBPACK FOOTER //
// ./src/utils/ticketKanban.js